import { createRequest } from 'utils/request';

import type { paths } from 'schemas/schema';

type TriviaCheck = paths['/trivia/{slug}/check/'];

const postTriviaCheck = createRequest<TriviaCheck, 'post'>('/pc/trivia/{slug}/check/', 'POST');

export default postTriviaCheck;
